'use strict';

/**
 * A directive that allows to interrupt the chain of events that end up changing state.
 * For convenience and other uses also prevents the execution of ng-click on the same element.
 * @see http://stackoverflow.com/questions/25600071/how-to-achieve-that-ui-sref-be-conditionally-executed
 */

eatClickIf.$inject = ['$parse', '$rootScope'];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = eatClickIf;
function eatClickIf($parse, $rootScope) {
  'ngInject';

  return {
    // this ensure eatClickIf be compiled before ngClick
    priority: 100,
    restrict: 'A',
    compile: function compile($element, attr) {
      var fn = $parse(attr.eatClickIf);
      return {
        pre: function link(scope, element) {
          var eventName = 'click';
          element.on(eventName, function (event) {
            var callback = function callback() {
              if (fn(scope, { $event: event })) {
                // prevents ng-click to be executed
                event.stopImmediatePropagation();
                // prevents href
                event.preventDefault();
                return false;
              }
            };
            if ($rootScope.$$phase) {
              scope.$evalAsync(callback);
            } else {
              scope.$apply(callback);
            }
          });
        },
        post: function post() {}
      };
    }
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/infocert-utils/distribution/utils.ui/eatClickIf.directive.js
// module id = 141
// module chunks = 2